import { createModelLoader } from './modelLoader';

export function createEnvironmentLoader(options) {
  const { loadPart } = createModelLoader('3d/draco/environments/', {
    ...options,
  });
  const { cleanUpBeforeLoad } = options;

  let environment;
  let currentEnv;
  let promise;

  const types = {
    default: 'halls',
    tent: 'tents',
  };

  async function load(buildingConfiguration) {
    const lastEnv = currentEnv;
    const type = types[buildingConfiguration?.itemIdentifier] || types.default;
    const size = buildingConfiguration?.length > 50 ? 'large' : 'default';
    currentEnv = `env_${type}_${size}`;
    if (lastEnv !== currentEnv) {
      cleanUpBeforeLoad && cleanUpBeforeLoad(environment);
      promise = loadPart(currentEnv);
      environment = (await promise).scene;
      promise = undefined;
    } else if (promise) {
      environment = (await promise).scene;
    }
    return environment;
  }

  return {
    load,
  };
}
